module.exports = __webpack_public_path__ + "static/media/runIconSemSobra.a3082183.svg";